// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Accordion, Box, Flex, type AccordionControlProps, getSpacing } from '@mantine/core';

import { isNotNil } from 'helpers/isNotNil';

type Props = {
  children?: ReactNode;
  leftSection?: ReactNode;
  rightSection?: ReactNode;
  controlProps?: AccordionControlProps;
};

/**
 * Renders an Accordion.Control component with actions on the left and right sides.
 */
export const AccordionControlsWithActions = ({ children, leftSection, rightSection, controlProps = {} }: Props) => (
  <Box pos="relative">
    {isNotNil(leftSection) && (
      <Flex
        pos="absolute"
        left={getSpacing('sm')}
        top="50%"
        align="center"
        gap="sm"
        style={{ transform: 'translateY(-50%)' }}
      >
        {leftSection}
      </Flex>
    )}
    {isNotNil(rightSection) && (
      <Flex
        pos="absolute"
        top="50%"
        right="calc(var(--mantine-spacing-xl) + var(--mantine-spacing-sm))"
        style={{ transform: 'translateY(-50%)' }}
        align="center"
        gap="sm"
      >
        {rightSection}
      </Flex>
    )}
    <Accordion.Control {...controlProps}>{children}</Accordion.Control>
  </Box>
);
